import React, { FunctionComponent } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import AppState from '@webapp/store/state';

import Grid from '@components/basics/grid';
import styled from 'styled-components';
import MetricIndicator from '@components/dashboard/metrics-widget/metric-indicator';
import { Translate } from 'react-localize-redux';
import { GetArtistAnalytics } from '@webapp/store/artist-analytics/action-creators';
import { AnalyticsQueryTypes } from '@services/analytics/types/analytics-query-enum';

interface AnalyticsGraphLegendProps {
  className?: string;
  data: {
    id: string;
    label: string;
    value: number;
    percentage: number;
  }[];
  isMobile: boolean;
  artistId?: string;
  getEngagementCountAnalytics: () => GetArtistAnalytics;
}

const mapStateToProps = (state: AppState) => ({
  data: [
    {
      id: 'streams',
      label: 'ANALYTICS.ENGAGEMENT.ACTIVITY.ITEMS.STREAMS',
      value: state.artistAnalytics.data?.streams.aggregatedCount,
      percentage: state.artistAnalytics.data?.streams.lastPercentChange,
    },
    {
      id: 'listeners',
      label: 'ANALYTICS.ENGAGEMENT.ACTIVITY.ITEMS.LISTENERS',
      value: state.artistAnalytics.data?.listeners.aggregatedCount,
      percentage: state.artistAnalytics.data?.listeners.lastPercentChange,
    },
    {
      id: 'saves',
      label: 'ANALYTICS.ENGAGEMENT.ACTIVITY.ITEMS.SAVES',
      value: state.artistAnalytics.data?.saves.aggregatedCount,
      percentage: state.artistAnalytics.data?.saves.lastPercentChange,
    },
    {
      id: 'downloads',
      label: 'ANALYTICS.ENGAGEMENT.ACTIVITY.ITEMS.DOWNLOADS',
      value: state.artistAnalytics.data?.downloads.aggregatedCount,
      percentage: state.artistAnalytics.data?.downloads.lastPercentChange,
    },
  ],
  artistId: state.artist.active?.id,
  isMobile: state.ui.mobile,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getEngagementCountAnalytics: () =>
    dispatch(
      new GetArtistAnalytics(AnalyticsQueryTypes.COUNTS, undefined, true)
    ),
});

const AnalyticsGraphLegend: FunctionComponent<AnalyticsGraphLegendProps> = ({
  className,
  data,
  isMobile,
  artistId,
  getEngagementCountAnalytics,
}) => {
  React.useEffect(() => {
    if (artistId) {
      getEngagementCountAnalytics();
    }
  }, [artistId, getEngagementCountAnalytics]);

  const getColor = (id: string) => {
    switch (id) {
      case 'streams':
        return undefined;
      case 'listeners':
        return 'warning';
      case 'saves':
        return 'grey';
      case 'downloads':
        return 'grey';

      default:
        return 'grey';
    }
  };

  return (
    <Grid gap={isMobile ? 20 : 30} className={className || ''}>
      {data.map((item) => (
        <MetricIndicator
          key={item.id}
          textTop={!isMobile}
          isVertical={isMobile}
          refText={<Translate id={item.label} />}
          label={item.value}
          labelFormat="none"
          indicatorColor={getColor(item.id)}
          value={item.percentage}
          valueFormat="percentage"
          isComingSoon={item.id === 'listeners'}
        />
      ))}
    </Grid>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(AnalyticsGraphLegend)`
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-content: space-between;
  flex-shrink: 0;
  @media ${({ theme }) => theme.device.tablet} {
    grid-column-gap: 60px;
  }
`);
